import { getLocalStorageChecklist } from '../utils/localStorageUtils';
import {
  GET_TECH_DOC_BEGIN,
  GET_CHECKLIST_SUCCESS,
  GET_TECH_DOC_FAILURE,
  DOC_PATH,
  DOC_CONFIG_FOLDER,
  DOC_FETCH_MODE,
  ALLETRAMP_OPT_BLUETOOTH,
  PAGENAME_PREINSTALLATION_BLUETOOTH,
  HPE_SIMPLIVITY,
  EXISTING_ESXI_CLUSTER,
  PAGENAME_PREINSTALLATION_SIMPLIVITY325,
  PAGENAME_PREINSTALLATION_SIMPLIVITY380,
  PAGENAME_PREINSTALLATION_SIMPLIVITY380PLUS,
  SIMPLIVITY_OPT_325GEN,
  SIMPLIVITY_OPT_325GEN_PLUSV2,
  SIMPLIVITY_OPT_380GEN,
  SIMPLIVITY_OPT_380GEN_PLUS,
  PAGENAME_PREINSTALLATION_EXISTING,
  PAGENAME_PREINSTALLATION_NEW,
  PAGENAME_PREINSTALLATION,
  PAGENAME_VALIDATE_ARRAY,
  NEW_ESXI_CLUSTER,
  SIMPLIVITY_OPT_325GEN11,
  PAGENAME_PREINSTALLATION_SIMPLIVITY325_GEN11,
  PAGENAME_PREINSTALLATION_SIMPLIVITY380_GEN11,
  SIMPLIVITY_OPT_380GEN11,
  MODEL_LIST_PCBE,
  PRODUCT_ID_ALLETRAB10K,
} from '../constants';
import { getTechDocFolderName } from '../config/productsConfig';
export const getChecklistBegin = () => ({
  type: GET_TECH_DOC_BEGIN,
});

export const getChecklistSuccess = (payload, pageName, model = '') => ({
  type: GET_CHECKLIST_SUCCESS,
  payload,
  pageName,
  model,
});

export const setChecklistDone = ({ checklist, summary = '', arrayModel, pageName, pageOpt, productName, dispatch }) => {
  const checkedIds = getLocalStorageChecklist({ pageName, productName, arrayModel, pageOpt });
  dispatch(
    getChecklistSuccess(
      {
        checklist,
        summary,
        checkedIds,
      },
      pageName,
      arrayModel,
    ),
  );
};

export const getChecklistFailure = e => ({
  type: GET_TECH_DOC_FAILURE,
  payload: e,
});

export const getChecklistAction = async function (params) {
  const { arrayModel, pageName, pageOpt, connectOpt, simplivitymodel, hpeAlletraDHCImodel, dispatch } = params;
  let newPageName = pageName;
  let { modelDocConfig, productName } = params;
  if (productName === PRODUCT_ID_ALLETRAB10K && connectOpt === ALLETRAMP_OPT_BLUETOOTH) {
    newPageName = PAGENAME_PREINSTALLATION_BLUETOOTH;
  }
  if (MODEL_LIST_PCBE.includes(arrayModel)) {
    switch (newPageName) {
      case PAGENAME_PREINSTALLATION:
        newPageName =
          hpeAlletraDHCImodel === EXISTING_ESXI_CLUSTER
            ? PAGENAME_PREINSTALLATION_EXISTING
            : PAGENAME_PREINSTALLATION_NEW;
        break;
      case PAGENAME_VALIDATE_ARRAY:
        newPageName =
          hpeAlletraDHCImodel === NEW_ESXI_CLUSTER || hpeAlletraDHCImodel === EXISTING_ESXI_CLUSTER
            ? PAGENAME_VALIDATE_ARRAY
            : null;
        break;
      default:
        break;
    }
  }
  if (arrayModel === HPE_SIMPLIVITY) {
    switch (simplivitymodel) {
      case SIMPLIVITY_OPT_325GEN:
      case SIMPLIVITY_OPT_325GEN_PLUSV2:
        newPageName = PAGENAME_PREINSTALLATION_SIMPLIVITY325;
        break;
      case SIMPLIVITY_OPT_380GEN:
        newPageName = PAGENAME_PREINSTALLATION_SIMPLIVITY380;
        break;
      case SIMPLIVITY_OPT_380GEN_PLUS:
        newPageName = PAGENAME_PREINSTALLATION_SIMPLIVITY380PLUS;
        break;
      case SIMPLIVITY_OPT_325GEN11:
        newPageName = PAGENAME_PREINSTALLATION_SIMPLIVITY325_GEN11;
        break;
      case SIMPLIVITY_OPT_380GEN11:
        newPageName = PAGENAME_PREINSTALLATION_SIMPLIVITY380_GEN11;
        break;
      default:
        break;
    }
  }

  if (typeof modelDocConfig === 'object') {
    productName = modelDocConfig.productId;
    modelDocConfig = modelDocConfig.configFileName;
  }
  const docFolderObj = getTechDocFolderName(productName);
  const docFolderName = docFolderObj.folderName;
  const docFilePath = `${DOC_PATH}${docFolderName}/`;
  const configFilePath = `${docFilePath}${DOC_CONFIG_FOLDER}`;
  dispatch(getChecklistBegin());
  try {
    const docsConfigJson = await fetch(configFilePath + modelDocConfig, DOC_FETCH_MODE);
    const docsConfig = await docsConfigJson.json();
    const docFileKey = pageOpt ? `${newPageName}-${pageOpt}` : newPageName;
    const docFileName = docsConfig[docFileKey] ? docsConfig[docFileKey] : docsConfig[newPageName];
    // const checklistContent = await fetch(docFilePath + docsConfig[pageName].replace(/\.md$/i, '.json'), DOC_FETCH_MODE);
    const checklistContent = await fetch(docFilePath + docFileName.replace(/\.md$/i, '.json'), DOC_FETCH_MODE);
    const { checklist, summary } = await checklistContent.json();
    const checkedIds = getLocalStorageChecklist({ newPageName, productName, pageOpt, connectOpt, arrayModel });
    dispatch(
      getChecklistSuccess(
        {
          checklist,
          summary,
          checkedIds,
        },
        newPageName,
        arrayModel,
      ),
    );
  } catch (e) {
    // console.log('>>>>Error in checklistAction:', e);
    dispatch(getChecklistFailure(e));
  }
};
